import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/OverflowMenu/overflow-menu';
import { OverflowMenuContext } from './OverflowMenuContext';
export var OverflowMenuControl = function OverflowMenuControl(_ref) {
  var className = _ref.className,
      children = _ref.children,
      hasAdditionalOptions = _ref.hasAdditionalOptions;
  return React.createElement(OverflowMenuContext.Consumer, null, function (value) {
    return (value.isBelowBreakpoint || hasAdditionalOptions) && React.createElement("div", {
      className: css(styles.overflowMenuControl, className)
    }, " ", children, " ");
  });
};